import { Vector2 } from 'three'
import { COMMANDERS } from '../../../../c.managers/LevelManager/store.d'
import { useSceneStore } from '../../../../a.scenes/GameScene/store'
import { ATTACK_TYPES, getRangeByAttack } from './getRangeByAttack'

const getTreasureAccessPositions = (owner: COMMANDERS): Vector2[] => {
  const lootStates = useSceneStore.getState().terrain.data.treasures
  const grid = useSceneStore.getState().terrain.data.grid
  const booty = lootStates.find(l => l.owner !== owner)
  const accessCoords = getRangeByAttack(ATTACK_TYPES.PUNCH, booty!.coords)
  const filteredCoords = accessCoords.filter(c => grid[c.x] && grid[c.x][c.y] && !c.equals(booty!.coords))

  return filteredCoords
}

export default getTreasureAccessPositions
